import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "animate-line__text" }

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { onMounted, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'animate-line-text',
  props: {
  text: { type: String, required: true },
  nameID: { type: String, required: true },
},
  setup(__props) {

const props = __props;



const isToggle = ref(false);

onMounted(() => {
  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.create({
    trigger: `#animate-line-${props.nameID}`,
    start: "top 60%",
    endTrigger: `#animate-line-${props.nameID}`,
    end: "bottom",
    onToggle: (self) => {
      if (self.isActive) isToggle.value = self.isActive;
    },
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `animate-line-${__props.nameID}`,
    class: "animate-line",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.text), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["animate-line__background", { 'animate-line__background--active': isToggle.value }])
    }, null, 2)
  ], 8, _hoisted_1))
}
}

})